import React from 'react';
import { useNavigate } from 'react-router-dom';
import BlankPageTemplate from '../Templates/BlankPageTemplate';
import ContainerFluid from '../ThemeComponents/grid/ContainerFluid';
import Row from '../ThemeComponents/grid/Row';
import Col from '../ThemeComponents/grid/Col';
import SmallBox from '../Templates/information/SmallBox';

const Dashboard = () => {
    const navigate = useNavigate();

    return (
        <BlankPageTemplate title="Mobility platform">
            <ContainerFluid>
                <Row>
                    <Col cols="col-lg-3 col-6">
                        <SmallBox
                            color="text-bg-primary"
                            title="My locations"
                            amount={1}
                            linkTitle="See my locations"
                            onPress={() => navigate('/backoffice/locations')}
                        />
                    </Col>
                    <Col cols="col-lg-3 col-6">
                        <SmallBox
                            color="text-bg-success"
                            title="My vehicles"
                            amount={1}
                            linkTitle="See my vehicles"
                            onPress={() => navigate('/backoffice/vehicles')}
                        />
                    </Col>
                </Row>
            </ContainerFluid>
        </BlankPageTemplate>
    )
}

export default Dashboard
